import React from "react";

import LargeContainer from "./home.large";
import SmallContainer from "./home.small";
import HomeRouter from "./home.router";

export interface IMenuContainerState {
  shouldUpdate: boolean;
  showMobileMenu: boolean;
}

export interface IChildContainerProps {
  showMobileMenu: boolean;
  handleMobileMenu: () => void;
}

export interface IHomeProps {
  username: string;
}

class Home extends React.Component<IHomeProps> {
  public render() {
    return (
      <>
        <LargeContainer
          showMobileMenu={true}
          handleMobileMenu={() =>
            console.log("handleMobileMenu LargeContainer")
          }
        >
          <HomeRouter {...this.props} />
        </LargeContainer>
        <SmallContainer
          showMobileMenu={true}
          handleMobileMenu={() =>
            console.log("handleMobileMenu SmallContainer")
          }
        >
          <HomeRouter {...this.props} />
        </SmallContainer>
      </>
    );
  }
}

export default Home;
